﻿import type {App, Plugin} from 'vue';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/nl-be';

export default {
    install(app: App): void {
        dayjs.extend(utc);
        dayjs.extend(customParseFormat);
        dayjs.locale('nl-be');
    },
} as Plugin;
